<template>
  <div class="registration-detail-template" theme>
    <div id="theme-registration-detail" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'registration',
      parts: [
        {
          elem: '#theme-registration-detail',
          htmlFile: 'registration_detail'
        }
      ]
    }
  },
  mounted() {
    if (this.loggedInUser) {
      this.openLink('/')
    }
  }
}
</script>
